/**
 * Unified PostHog telemetry gate for browser, Next.js Node, and Next.js Edge.
 * Fail closed: only the exact string "true" permits PostHog egress.
 */
export function isPostHogTelemetryEnabled(): boolean {
  return process.env.NEXT_PUBLIC_POSTHOG_TELEMETRY_ENABLED === "true"
}

export interface PostHogFeatureFlagClient {
  getFeatureFlag: (key: string) => string | boolean | undefined
  onFeatureFlags?: (callback: () => void) => (() => void) | void
  get_distinct_id?: () => string
}

export function getPostHogFeatureFlagClient<
  T extends PostHogFeatureFlagClient = PostHogFeatureFlagClient,
>(): T | null {
  if (!isPostHogTelemetryEnabled() || typeof window === "undefined") return null
  const client = (window as unknown as { posthog?: T }).posthog
  if (!client || typeof client.getFeatureFlag !== "function") return null
  return client
}
